document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
      menu.hidden = expanded;
      document.body.classList.toggle('menu-open', !expanded);
    });
  }

  document.querySelectorAll('[data-mobile-menu] a').forEach((link) => {
    link.addEventListener('click', () => {
      if (!toggle || !menu) return;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      menu.hidden = true;
      document.body.classList.remove('menu-open');
    });
  });

  const productSubject = new URLSearchParams(window.location.search).get('subject');
  const requestedProduct = productSubject?.toUpperCase() === 'X-MAKER JOY' ? 'TKID' : productSubject;
  const productSelect = document.querySelector('[data-product-interest]');

  if (requestedProduct && productSelect) {
    const matchingOption = Array.from(productSelect.options).find(
      (option) => option.value.toLowerCase() === requestedProduct.toLowerCase()
    );
    if (matchingOption) productSelect.value = matchingOption.value;
  }

  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const previous = carousel.querySelector('[data-carousel-previous]');
    const next = carousel.querySelector('[data-carousel-next]');

    if (!track || !previous || !next) return;

    const updateButtons = () => {
      const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximumScroll - 2;
    };

    const scrollOneCard = (direction) => {
      const card = track.querySelector('.product-card, .jc-product-tile');
      if (!card) return;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.dataset.motion === 'paused' ? 'auto' : 'smooth' });
    };

    previous.addEventListener('click', () => scrollOneCard(-1));
    next.addEventListener('click', () => scrollOneCard(1));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    if ('ResizeObserver' in window) new ResizeObserver(updateButtons).observe(track);
    updateButtons();
  });
});
